// import CryptoJS from 'crypto-js';
// import Cookies from 'js-cookie';
// import { publicIpv4 } from "public-ip";
// import React, { useState, useEffect } from 'react';

// class PaymentService {

//     createPayment = async (amount, invoiceID, paymentMethod, invoiceType, orderDetailID, packagenew, promocode) => {
//         try {
//             const token = Cookies.get("Token");

//             let returnUrl;
//             if (invoiceType == "createvm") {
//                 returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thanks`;

//             }
//             else if (invoiceType == "upgrade") {
//                 returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thanks`;

//             }
//             else if (invoiceType == "recharge") {
//                 returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thank-you/recharge`;

//             }
//             const [ipAddress, setIpAddress] = useState("");
//             useEffect(() => {
//                 const fetchIp = async () => {
//                     try {
//                         const ip = await publicIpv4();
//                         setIpAddress(ip);
//                     } catch (error) {
//                         console.error("Lỗi khi lấy IP:", error);
//                     }
//                 };
//                 fetchIp();
//             }, []);
//             const payload = {
//                 amount: parseFloat(amount).toFixed(2),
//                 invoiceID: invoiceID,
//                 paymentMethod: paymentMethod,
//                 returnUrl: returnUrl,
//                 invoice_type: invoiceType,
//                 order_detail_id: orderDetailID,
//                 packagenew: packagenew,
//                 promocode: promocode,
//                 ip_address: ipAddress,
//             };

//             const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/payment/neox/create-url`, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${token}`,
//                 },
//                 body: JSON.stringify(payload),
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 if (data.success) {
//                     return data.paymentUrl;
//                 }
//             }
//             return null;
//         } catch (error) {
//             console.error("Error creating payment:", error);
//             return null;
//         }
//     };


// }

// export default PaymentService;
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

class PaymentService {
    
    createPayment = async (amount, invoiceID, paymentMethod, invoiceType, orderDetailID, packagenew, promocode) => {
        try {
            const token = Cookies.get("Token");

            let returnUrl;
            if (invoiceType == "createvm") {
                returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thanks`;

            }
            else if (invoiceType == "upgrade") {
                returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thanks`;

            }
            else if (invoiceType == "recharge") {
                returnUrl = `${process.env.REACT_APP_BANK_RETURN_URL}/thank-you/recharge`;

            }
            const payload = {
                amount: parseFloat(amount).toFixed(2),
                invoiceID: invoiceID,
                paymentMethod: paymentMethod,
                returnUrl: returnUrl,
                invoice_type: invoiceType,
                order_detail_id: orderDetailID,
                packagenew: packagenew,
                promocode: promocode
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/payment/neox/create-url`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    return data.paymentUrl;
                }
            }
            return null;
        } catch (error) {
            console.error("Error creating payment:", error);
            return null;
        }
    };


}

export default PaymentService;
